<mic-alert-center position="bottom left" />
<div class="flex flex-row h-full mic-login">
  <div class="flex flex-col justify-center items-center h-full grow-1 gap-5">
    <div class="flex flex-row justify-center">
      <p class="text-3xl app-name"><span class="app-name-principal">CAR</span>DEALER</p>
    </div>
    @if (expired) {
    <div>
      <p>O link para a redefinição da senha expirou.</p>
      <mic-link label="Solicitar novo Link" icon="chevron_right" routerLink="/auth/password"></mic-link>
    </div>
    } @else if(passwordChanged) {
    <div>
      <p>Senha atualizada com sucesso!</p>
      <mic-link label="Fazer Login" icon="chevron_right" routerLink="/auth/login"></mic-link>
    </div>
    } @else {
    <div class="d-none flex flex-col md-w-5on12 sm-w-8on12 justify-center gap-2" [formGroup]="form">
      <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
        <p>Atualizar Senha</p>
        <div class="d-flex flex-col" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>Nova Senha</mat-label>
            <input matInput type="password" required formControlName="password" />
          </mat-form-field>
          <mat-form-field style="width: 100%">
            <mat-label>Confirmar Nova Senha</mat-label>
            <input matInput type="password" required formControlName="confirmPassword" />
          </mat-form-field>
        </div>
        <div class="flex flex-row justify-between align-center">
          <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="updatePassword()">
            <mat-icon>login</mat-icon>
            <span>Atualizar Senha</span>
          </button>
          <mic-link label="Fazer Login" icon="chevron_right" routerLink="/auth/login"></mic-link>
        </div>
      </mic-spinner-overlay>
    </div>
    }
    <div class="flex flex-row items-center justify-center gap-4 mic-login-footer mt-14">
      <p>Powered by</p>
      <mic-logo type="group"></mic-logo>
    </div>
  </div>
  <div class="md-hidden" [ngClass]="{ 'mic-login-trapeze': !image, 'mic-login-image': image, 'w-4on12': !image, 'w-1on2': image }"></div>
</div>
